export type PartnerCityId = 'miami' | 'madrid' | 'barcelona';

export type PricingPlanCategory = 'food' | 'wellness';

export type PartnerFeatureIconId = 'profile' | 'map' | 'recommend' | 'exclusivity' | 'analytics';

export const PARTNER_CITIES: { id: PartnerCityId; label: string }[] = [
  { id: 'miami', label: 'Miami' },
  { id: 'madrid', label: 'Madrid' },
  { id: 'barcelona', label: 'Barcelona' },
];
